import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { DialogClose } from "@tenant/ui";
import styles from "./PerkDialogs.module.scss";
import { ActionButton } from "@/components/ActionButton";

interface PerkDialogButtonsProps {
  showSeeRulesButton?: boolean;
  rulesUrl?: string;
}

export const PerkDialogButtons = ({
  showSeeRulesButton = true,
  rulesUrl,
}: PerkDialogButtonsProps) => {
  const [, cn] = useModuleBEM(styles, "PerkDialogs");
  const { t } = useI18nContext();

  return (
    <div className={cn("buttons-container")}>
      <DialogClose className={cn("dialog-close")}>
        <ActionButton message={t("home.perks.closeDialog")} />
      </DialogClose>
      {showSeeRulesButton && rulesUrl && (
        <ActionButton
          to={rulesUrl}
          message={t("home.perks.seeRules")}
          defaultStyle="outlined"
        />
      )}
    </div>
  );
};
